export default {
  message: {
    Tour: {
      continue: "계속",
      back: "뒤로",
      finish: "완료"
    },
    Login: {
      title: "학부모 로그인",
      sign_in: "로그인",
      login_fail: "인증에 실패했습니다. 다시 시도하거나 학교에 문의하여 로그인 도움을 받으세요.",
      forgot_password: "비밀번호 찾기",
      create_account: "계정 만들기",
      password: "비밀번호",
      confirm_password: "비밀번호 확인",
      password_reminder: "비밀번호 알림",
      enter_email: "이메일 주소 입력",
      validation_error: "유효성 검사 오류 메시지",
      password_reminder_error_no_user_register:
        "입력하신 사용자 이름을 찾을 수 없습니다. 다시 시도하거나 새 계정을 만드세요.",
      password_reminder_error_no_user: "입력하신 사용자 이름을 찾을 수 없습니다.",
      password_reminder_sent: "추가 안내가 포함된 이메일이 {email}로 전송되었습니다.",
      password_reminder_sent_message:
        "이메일이 도착하는 데 몇 분 정도 걸릴 수 있습니다. 받은 편지함에 없으면 스팸 폴더를 확인하세요.",
      password_trouble_email: "여전히 문제가 있으시면 {email}로 문의하세요.",
      password_trouble_school: "여전히 문제가 있으시면 학교에 문의하세요.",
      return_to_sign_in: "로그인으로 돌아가기",
      create_my_account: "내 계정 만들기",
      or_sign_in_with: "또는 다음으로 로그인",
      password_reset: "계정의 새 비밀번호를 선택하세요.",
      password_reset_warning:
        "비밀번호 변경을 요청하지 않으셨다면 즉시 학교 관리자에게 문의하세요.",
      password_update: "새 비밀번호 선택",
      password_update_confirm: "새 비밀번호 확인",
      password_update_success: "새 비밀번호가 저장되었습니다."
    },
    AccountSettings: {
      title: "계정 설정",
      first_name: "이름",
      last_name: "성",
      email: "이메일",
      username: "사용자 이름",
      password: "비밀번호",
      students: "학생",
      teachers: "선생님",
      external_id: "외부 ID",
      phone: "전화번호",
      phone_required: "전화번호는 필수입니다",
      edit: "편집",
      remove: "제거",
      add: "추가",
      remove_message: "이 학생 이름을 제거하시겠습니까?",
      yes: "예",
      no: "아니오",
      add_student: "학생 추가",
      close: "닫기",
      save: "변경사항 저장",
      cancel: "취소",
      student_alert_message: "최소 한 명의 학생을 입력해야 합니다.",
      logout: "로그아웃"
    },
    Navbar: {
      my_meetings: "내 회의",
      language: "한국어",
      help: "도움말",
      account_settings: "계정 설정",
      logout: "로그아웃"
    },
    SubNavbar: {
      meeting: "회의",
      event: "이벤트",
      print: "인쇄",
      email: "이메일",
      export: "내보내기"
    },
    ConferenceCard: {
      add_edit_meetings: "회의 추가/편집",
      opening: "진행 중",
      closed: "종료됨"
    },
    Agenda: {
      full_agenda: "전체 일정",
      empty_state_title: "회의를 찾을 수 없습니다.",
      empty_state_message: "질문이 있으시면 학교 담당자에게 문의하세요.",
      confirmation_modal_title: "일정 확인됨",
      confirmation_modal_message: "일정이 성공적으로 확인되었으며 이메일이 전송되었습니다.",
      complete_button: "완료!"
    },
    AgendaCard: {
      room: "회의실 이용 불가",
      room_with_value: "회의실: {room}",
      virtual_meeting: "화상 회의",
      all_conferences: "모든 회의",
      conference: "회의",
      student: "학생",
      meeting_with: "회의 대상",
      date_time: "날짜/시간",
      meeting_type: "회의 유형",
      location: "위치",
      comment: "코멘트",
      action: "작업",
      delete: "삭제",
      add_comment: "코멘트 추가",
      join: "회의 참여",
      choose_meeting_type: "회의 유형 선택",
      in_person: "대면",
      phone: "전화",
      callback: "콜백",
      virtual: "화상",
      unavailable: "이용 불가",
      tooltip_translator: "통역 서비스는 보장되지 않지만 학교에서 최선을 다해 제공하려고 합니다.",
      translator_requested: "{language} 통역 요청됨",
      clear_translator: "통역 요청 취소",
      need_translator: "통역이 필요하신가요?",
      choose_language: "언어 선택"
    },
    ScheduleMatrix: {
      no_teachers_title: "선생님 또는 팀이 선택되지 않았습니다.",
      no_teachers_message: "회의 시간을 보려면 선생님을 선택하세요.",
      choose_teachers_button: "이용 가능한 선생님 또는 팀 보기",
      choose_student: "어느 학생입니까?",
      cancel: "취소"
    },
    Matrix: {
      teachers: "선생님",
      agenda: "확인하고 계속"
    },
    DrawerTeachers: {
      teachers: "선생님",
      name: "이름",
      description: "설명",
      student: "학생",
      teacher_team: "선생님/팀",
      show_more: "더 많은 선생님 보기",
      show_all: "학교의 모든 선생님 보기",
      selected: "({count}) 선택됨",
      closeDrawer: "일정 계속",
      search: "선생님 또는 팀 검색",
      not_available: "이 선생님은 {date}에 이용 가능한 회의 시간이 없습니다."
    },
    DrawerAgenda: {
      no_meetings_title: "예정된 회의가 없습니다.",
      no_meetings_message: "선생님과 시간대를 선택하면 여기에 표시됩니다.",
      new_meeting_label: "신규",
      cancel_button: "취소",
      student_label: "학생",
      meeting_type_location: "회의 유형/위치",
      comment_label: "코멘트",
      save_comment_button: "코멘트 저장",
      confirm_label: "확인하세요:",
      confirm_cancel_button: "예, 회의를 취소합니다",
      do_not_cancel_button: "취소하지 않음",
      confirm_agenda_button: "이 일정 확인",
      confirm_agenda_message_line1: "언제든지 돌아와서 변경할 수 있습니다.",
      confirm_agenda_message_line2: "현재 일정이 이메일로 전송됩니다."
    },
    EmailConsent: {
      message:
        "개인정보 보호와 보안을 위해 시스템에서 이메일 주소로 통신을 받는 것에 동의해 주셔야 합니다.",
      consent: "동의"
    }
  }
};
